export default __webpack_public_path__ + "helppage.MD";